<app-request-details *ngIf="requestId"></app-request-details>

<app-Restudy-economic-manager [isShow]="false" [baseRequestId]="requestId" [showRequestDetails]="false" *ngIf="true"></app-Restudy-economic-manager>
